import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/AuthProvider/AuthProvider';
import useTitle from '../../hooks/useTittle';
import MyReview from './MyReview';

const MyReviews = () => {
    useTitle('My Reviews');
    const { user } = useContext(AuthContext);
    const [reviews, setReviews] = useState([]);
    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true);
        fetch(`https://salma-kitchen-server.vercel.app/my-reviews?email=${user.email}`, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('smkToken')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                setReviews(data);
            })
    }, [user?.email])

    const handleDeleteRev = (id) => {
        const proceed = window.confirm("Are you sure?");
        if (proceed) {
            fetch(`https://salma-kitchen-server.vercel.app/review/${id}`, {
                method: 'DELETE'
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                    if (data.deletedCount > 0) {
                        alert("Deleted Successfully");
                        const remaining = reviews.filter(rev => rev._id !== id);
                        setReviews(remaining);
                    }
                })
        }
    }

    const handleUpdateRev = (id, updatedReview) => {
        console.log(id, updatedReview);
        fetch(`https://salma-kitchen-server.vercel.app/review/${id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(updatedReview)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.modifiedCount > 0) {
                    const remaining = reviews.filter(rev => rev._id !== id);
                    const changedRev = reviews.find(rev => rev._id === id)
                    changedRev.review = updatedReview.review;
                    const newReviews = [changedRev, ...remaining]
                    setReviews(newReviews);
                    toast("Updated Successfully");
                }
            })
    }

    return (
        <>
            <h1 className='text-3xl text-center mt-24 mb-12'>My Reviews</h1>
            <div className="overflow-x-auto w-full mb-24">
                {
                    isLoading ?
                        <div class="shadow rounded-md p-4 w-full mx-auto">
                            <div class="animate-pulse flex space-x-4">
                                <div class="rounded-full bg-slate-700 h-10 w-10"></div>
                                <div class="flex-1 space-y-6 py-1">
                                    <div class="h-2 bg-slate-700 rounded"></div>
                                    <div class="space-y-3">
                                        <div class="grid grid-cols-3 gap-4">
                                            <div class="h-2 bg-slate-700 rounded col-span-2"></div>
                                            <div class="h-2 bg-slate-700 rounded col-span-1"></div>
                                        </div>
                                        <div class="h-2 bg-slate-700 rounded"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        reviews.length > 0 ?
                            <>
                                <table className="table w-full lg:table-fixed">
                                    <thead>
                                        <tr>
                                            <th className='hidden'></th>
                                            <th className='static'>Item Name</th>
                                            <th>Username</th>
                                            <th>Review</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            reviews.map(review => <MyReview key={review._id} review={review} handleUpdateRev={handleUpdateRev} handleDeleteRev={handleDeleteRev}></MyReview>)
                                        }
                                    </tbody>
                                </table>
                            </> :
                            <>
                                <h1 className='text-2xl'>No reviews were added</h1>
                            </>

                }
            </div>
        </>
    );
};

export default MyReviews;